export const categories = [
  {
    id: 'cat-1',
    name: '平台入门',
    slug: 'platform-intro',
    description: '快速了解开云平台的基础功能与核心概念，帮助新用户完成注册与初步配置。',
    icon: 'ri-rocket-line',
  },
  {
    id: 'cat-2',
    name: '功能指南',
    slug: 'feature-guide',
    description: '深入探索开云的各项高级功能，掌握高效使用技巧与最佳实践。',
    icon: 'ri-guide-line',
  },
  {
    id: 'cat-3',
    name: '使用场景',
    slug: 'use-cases',
    description: '了解开云在不同行业与场景中的应用案例，发现适合您的解决方案。',
    icon: 'ri-lightbulb-line',
  },
  {
    id: 'cat-4',
    name: '更新动态',
    slug: 'updates',
    description: '关注开云平台的最新更新、版本发布与功能优化动态。',
    icon: 'ri-flashlight-line',
  },
  {
    id: 'cat-5',
    name: '常见问题',
    slug: 'faq',
    description: '查找常见问题的解答，快速解决使用过程中的疑惑与困难。',
    icon: 'ri-question-answer-line',
  },
  {
    id: 'cat-6',
    name: '最佳实践',
    slug: 'best-practices',
    description: '学习行业专家总结的开云平台最佳实践方法，提升使用效率。',
    icon: 'ri-medal-line',
  },
];